import styled from 'styled-components';

import { Text } from '../../../../components';

// The coloured disc. `$bg` is the deterministic palette colour for the email
// (resolved in `format.ts` from AVATAR_PALETTE — the literal lives in tokens, not
// here). `$size` drives the diameter and the glyph size together.
export const Disc = styled.span<{ $bg: string; $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  background: ${(p) => p.$bg};
  user-select: none;
`;

export const Initial = styled(Text)<{ $fg: string; $size: number }>`
  font-weight: 700;
  font-size: ${(p) => Math.round(p.$size * 0.42)}px;
  line-height: 1;
  color: ${(p) => p.$fg};
`;
